<div #container class="inline-flex items-center relative p-0 rounded-full overflow-hidden shadow-lg bg-unselected h-10">
  
  <div #slider class="absolute top-0 bottom-0 left-0 h-full transition-all duration-300 ease-[cubic-bezier(0.4,0,0.2,1)] z-0 rounded-full bg-selected"></div>

  <button 
    #btnFirst
    (click)="setMode('first')" 
    class="relative z-10 flex items-center gap-2.5 px-4 py-2 rounded-full text-[16px] font-poppins leading-6 font-medium transition-colors duration-300 ease-in-out"
    [ngClass]="{
      'text-white': isFirstSelected(),
      'text-inactive': !isFirstSelected()
    }">
    @if (firstOption.logo) {
      <i [class]="firstOption.logo" class="w-6 h-6 text-2xl"></i>
    }
    @if(firstOption.label){
      <span class="hidden xs:block">{{ firstOption.label }}</span>
    }
  </button>

  <button 
    #btnSecond
    (click)="setMode('second')" 
    class="relative z-10 flex items-center gap-2.5 px-4 py-2 rounded-full text-[16px] font-poppins leading-6 font-medium transition-colors duration-300 ease-in-out"
    [ngClass]="{
      'text-white': isSecondSelected(),
      'text-inactive': !isSecondSelected()
    }">
    @if(secondOption.logo){
      <i [class]="secondOption.logo" class="w-6 h-6 text-2xl"></i>
    }
    @if(secondOption.label){
      <span class="hidden xs:block">{{ secondOption.label }}</span>
    }
  </button>
</div>